//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import HelloWorld from './components/HelloWorld';

export default {
    name: "App",
    data: () => ({
        //
    }),
};
